import { Dialog as DrawerPrimitive } from "radix-ui";

export const DrawerRoot = DrawerPrimitive.Root;
